import React from "react";
import { useFormikContext } from "formik";
import { FormStatus as FormStatusType, FormValues } from "pages/eligibility/type";
import { humanizeFormType } from "utils/form-types";
import { FormData } from "types/gql-types";
import MobileSectionsButton from "../section/mobile-sections-button";

type MobileMenu = {
  isMobile: boolean;
  toggle: () => void;
}

const FormStatus: React.FC<{
  mobileMenu: MobileMenu,
  showCertificationWarning: boolean,
  form: FormData
}> = ({ mobileMenu, form, showCertificationWarning }) => {
  const formContext = useFormikContext<FormValues>();
  const status = formContext.status as FormStatusType | null;
  const errors = {
    [FormStatusType.ServerError]: (
      <div className="alert alert-danger">
      There was an unexpected problem when attempting to save the form. If the problem
      persists please contact <a href="support@havenconnect.com">support@havenconnect.com</a>.
      </div>
    ),
    [FormStatusType.ValidationError]: (
      <>
        <div className="alert alert-warning">
          {mobileMenu.isMobile && <span>Missing information, please review:&nbsp;</span>}
          <MobileSectionsButton {...mobileMenu} />
          {!mobileMenu.isMobile && <span>Missing information, please review the sidebar.</span>}
        </div>
        {showCertificationWarning &&
        <div className="alert alert-warning">
          Please agree with the certification to {form.skipSignature ? "submit" : "sign"} this {humanizeFormType(form.type)}.
        </div>}
      </>
    ),
  };
  if (status === null || !(status in errors)) return null;
  return (<div style={{ marginBottom: 16 }}>{errors[status]}</div>);
};

export default FormStatus;
